document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('sticky-header');

  window.addEventListener('scroll', () => {

    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

  });

});


const inlineMenu = document.querySelector(".header__inline-menu");

const detailsItems = inlineMenu.querySelectorAll("details");

 

detailsItems.forEach(item => {

const ulElement = item.querySelector("ul");

 

item.addEventListener("mouseover", () => {

item.setAttribute("open", true);

 

ulElement.addEventListener("mouseleave", () => {

item.removeAttribute("open");

});

 

item.addEventListener("mouseleave", () => {

item.removeAttribute("open");

});

});

});
